// Lightweight helper that rewrites image URLs to ask the upstream CDN for a
// thumbnail-sized variant. Used everywhere we render a small preview (playlist
// editor, design picker, asset library card, etc.) so the browser never
// downloads multi-megabyte hero images for a 64×64 thumb.
//
// Supports the two CDNs that ship the bulk of our stock + uploaded photos:
//   - Pexels   (images.pexels.com?auto=compress&w=...)
//   - Unsplash (images.unsplash.com?w=...)
//
// For everything else we pass the URL through unchanged.
export function thumbUrl(url, width = 320) {
  if (!url || typeof url !== "string") return url;
  try {
    if (url.includes("images.pexels.com")) {
      const u = new URL(url);
      u.searchParams.set("auto", "compress");
      u.searchParams.set("cs", "tinysrgb");
      u.searchParams.set("w", String(width));
      u.searchParams.set("dpr", "1");
      u.searchParams.delete("h"); // let the CDN preserve aspect ratio
      return u.toString();
    }
    if (url.includes("images.unsplash.com")) {
      const u = new URL(url);
      u.searchParams.set("w", String(width));
      u.searchParams.set("q", "70");
      u.searchParams.set("auto", "format");
      return u.toString();
    }
  } catch {
    // malformed URL → fall through and return as-is
  }
  return url;
}
